import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslate } from 'react-translate.ts';

import { ChangePasswordForm } from '../../../common/components/forms/ChangePasswordForm';
import { SIGN_IN_PATH } from '../../../constants/route.constants';
import AuthSelectors from '../../../auth/selectors/AuthSelectors';
import AuthActions from '../../../auth/actions/AuthActions';
import { TRANSLATIONS_ROOT_KEY } from '../../../constants/translation.constants';
import { type AppDispatch } from '../../../reducers/store';
import { NotificationActions } from '../../../common/actions/NotificationActions';
import AuthLayout from '../AuthLayout/AuthLayout';
import AuthCard from '../../../components/auth/AuthCard/AuthCard';

export function ResetPassword() {
    const translate = useTranslate(TRANSLATIONS_ROOT_KEY + '.change-password');

    const dispatch = useDispatch<AppDispatch>();
    const { token } = useParams<{ token: string | undefined }>();
    const { loading } = useSelector(AuthSelectors.getPasswordReset);
    const navigate = useNavigate();

    useEffect(() => {
        return () => {
            // noinspection JSVoidFunctionReturnValueUsed
            dispatch(AuthActions.reinit());
        };
    }, [dispatch]);

    return (
        <>
            <AuthLayout>
                <AuthCard
                    isLoading={loading}
                    header={
                        <div className="text-primary uppercase">
                            {translate('title')}
                        </div>
                    }
                >
                    <ChangePasswordForm
                        token={token}
                        onSubmit={resetPassword}
                    />
                </AuthCard>
            </AuthLayout>
        </>
    );

    async function resetPassword(controlPassword: string, password: string) {
        try {
            await dispatch(
                AuthActions.resetPassword({ controlPassword, password }),
            ).unwrap();
            dispatch(NotificationActions.success(translate('success')));
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e: any) {
            dispatch(NotificationActions.error(translate('error')));
        } finally {
            navigate(SIGN_IN_PATH, { relative: 'path' });
        }
    }
}
